module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pt-2 px-4"
  }, [_c('top-area', {
    attrs: {
      "reservation": _vm.reservation
    }
  }), _vm._v(" "), (_vm.showTicketPicker) ? _c('person-ticket-selector', {
    attrs: {
      "reservation": _vm.reservation,
      "readOnly": _vm.getIsAddingReservation
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bg-lightest radius-normal border-light my-3"
  }, [_c('div', {
    staticClass: "col-sm-12 pt-3"
  }, [_c('h5', {
    staticClass: "w-100"
  }, [_vm._v("Customer Details")]), _vm._v(" "), _c('customer-details', {
    attrs: {
      "reservation": _vm.reservation
    }
  })], 1)]), _vm._v(" "), (_vm.showBillinDetailsForm) ? _c('div', {
    staticClass: "bg-lightest radius-normal border-light mt-3"
  }, [_c('div', {
    staticClass: "col-sm-12 pt-3"
  }, [_c('h5', {
    staticClass: "w-100"
  }, [_vm._v("Billing Details")]), _vm._v(" "), _c('billing-details', {
    attrs: {
      "reservation": _vm.reservation
    }
  })], 1)]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-2959c614", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2959c614"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/NewReservation/Resume/Details.vue
// module id = 1781
// module chunks = 0